module.exports = __webpack_public_path__ + "img/p3_mitaowuyu.e279f2e4.jpg";